import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_URL ?? '';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: attach JWT from localStorage
apiClient.interceptors.request.use((config) => {
  const stored = localStorage.getItem('xcodec-auth');
  if (stored) {
    try {
      const parsed = JSON.parse(stored) as { state?: { token?: string } };
      const token = parsed?.state?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // ignore malformed storage
    }
  }
  return config;
});

// Response interceptor: on 401, clear auth and redirect to /login
apiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 401 &&
      !window.location.pathname.startsWith('/login')
    ) {
      localStorage.removeItem('xcodec-auth');
      window.location.href = '/login';
    }
    // An account whose password somebody else set can do nothing else.
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 403 &&
      JSON.stringify(error.response.data ?? '').includes('password change required') &&
      !window.location.pathname.startsWith('/change-password')
    ) {
      window.location.href = '/change-password';
    }
    // A restreamer's login can't do anything until two-factor is on.
    if (
      axios.isAxiosError(error) &&
      error.response?.status === 403 &&
      JSON.stringify(error.response.data ?? '').includes('two-factor enrollment required') &&
      !window.location.pathname.startsWith('/settings/2fa')
    ) {
      window.location.href = '/settings/2fa';
    }
    return Promise.reject(error);
  }
);
